(function() {
  'use strict';

  function notificationBar($rootScope, $transitions, localStorageService) {
    function link(scope, el, attrs) {

      if (!String.hashCode) {
        String.prototype.hashCode = function() {
          var hash = 0,
            i, chr, len;
          if (this.length === 0) return hash;
          for (i = 0, len = this.length; i < len; i++) {
            chr = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
          }
          return hash;
        };
      }

      var text = scope.text;
      var hash = text.hashCode();

      scope.showNotification = null;

      var openNotification = function() {
        if (
            !localStorageService.cookie.get('notifyCode') ||
            (localStorageService.cookie.get('notifyCode') &&
            (localStorageService.cookie.get('notifyCode') !== hash))
          ) {
          scope.showNotification = true;
          scope.notificationStyle = { 'background-color': scope.backgroundColor };
        }
      };

      var clearCookie = function() {
        localStorageService.cookie.remove('notifyCode');
        openNotification();
      };

      var runOrNot = function(fromStateName, toStateName) {
        /**
         * urls que não devem mostrar a barra
         **/
        var notificationUrlRules = {
          'redirecionar': [''],
          'rastreamento': [''],
          'termos-de-uso': ['', 'endereco', 'gasto-mensal', 'documento', 'redirecionar'],
          'atualizar-termos-de-uso': ['', 'redirecionar'],
          'documento': ['', 'endereco', 'gasto-mensal', 'redirecionar'],
          'gasto-mensal': ['', 'documento', 'endereco', 'redirecionar'],
          'endereco': ['', 'documento', 'gasto-mensal', 'redirecionar'],
        };

        if (!scope.text || (notificationUrlRules[toStateName] || []).indexOf(fromStateName) > -1) {
          return;
        } else if ( scope.force && (localStorageService.cookie.get('notifyCode') !== hash) ) {
            clearCookie();
          } else {
            openNotification();
          }
      };

      scope.closeNotification = function() {
        localStorageService.cookie.set('notifyCode', hash, null);
        scope.showNotification = null;
      };

      $transitions.onStart({}, function(transition) {
        runOrNot(transition.$from().name, transition.$to().name);
      });

    }

    /**
     * direcitve definition object - objeto que carrega as configurações da diretiva
     **/
    var ddo = {
      restrict: 'E',
      scope: {
        text: '@',
        danger: '=',
        force: '=',
        hideCloseBtn: '=',
        description: '=',
        backgroundColor: '='
      },
      template: require('./notification-bar.html'),
      replace: true,
      link
    };

    return ddo;
  }

  angular
    .module('mandaeApp')
    .directive('notificationBar', notificationBar);
}());
